/**
 * BusinessHome — Inicio Ola A v2 (misma lógica que personas InicioHub).
 * Hub: greet → balances → actions → ruta → grid-3 → strip → tertiary.
 * Oráculo voice/chat viven abajo / overlay; NO banner oro primero.
 */
import { useEffect, useState, useRef } from 'react';
import { useSnapshot } from 'valtio';
import { state } from '../../store/global';
import API from '../../lib/api';
import { myBusinesses, listBatches } from '../../lib/business';
import BusinessOraculo from './BusinessOraculo';
import ConvertCurrencyModal from '../../components/ConvertCurrencyModal';
import OraculoVoice from '../../components/OraculoVoice';
import BusinessInicioHub from '../../components/BusinessInicioHub';

export default function BusinessHome() {
  const snap = useSnapshot(state);
  const [business, setBusiness] = useState(null);
  const [batches, setBatches] = useState([]);
  const [saldos, setSaldos] = useState(null);
  const [showConvert, setShowConvert] = useState(false);
  const [loading, setLoading] = useState(true);
  const [voiceOpen, setVoiceOpen] = useState(false);
  const [retomarVoz, setRetomarVoz] = useState(0);
  const [pending, setPending] = useState(null);
  const chatRef = useRef(null);

  useEffect(() => {
    Promise.allSettled([
      API.get('user/getDashboardInfo').then((res) => {
        const d = res.data?.data || {};
        setSaldos({ cop: d.balance_cop ?? 0, usd: d.balance_usdc ?? d.balance ?? 0 });
      }),
      myBusinesses().then((list) => {
        setBusiness(list[0] || null);
        if (list[0]) return listBatches(list[0]._id).then(setBatches);
      }),
    ]).finally(() => setLoading(false));
  }, []); // eslint-disable-line

  if (loading) {
    return <div className="text-center py-10 text-[#9CA3AF]">Cargando...</div>;
  }

  const pendientes = batches.filter(
    (b) => b.status === 'PENDIENTE_APROBACION' || b.status === 'BORRADOR',
  );

  const askFromHub = (t) => {
    setPending(t);
    setTimeout(() => chatRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 80);
  };

  return (
    <div className="max-w-5xl">
      <BusinessInicioHub
        businessName={business?.name}
        nit={business?.nit}
        firstName={snap.user?.firstName}
        balanceCop={saldos?.cop ?? 0}
        balanceUsd={saldos?.usd ?? 0}
        pendientes={pendientes}
        batches={batches}
        onConvert={() => setShowConvert(true)}
        onVoice={() => setVoiceOpen(true)}
        onAsk={askFromHub}
      />

      {/* Chat embebido: recibe pregunta del panel Oráculo del hub (sample / texto) */}
      <div ref={chatRef} className="mt-4">
        <BusinessOraculo
          pending={pending}
          onConsumed={() => setPending(null)}
          retomarVoz={retomarVoz}
          onConvertir={(accion) => setShowConvert({ direccion: accion.direccion, monto: accion.monto })}
        />
      </div>

      {voiceOpen && (
        <OraculoVoice
          basePath="/api/business-oraculo"
          onClose={() => setVoiceOpen(false)}
          onIrAlChat={() => {
            setVoiceOpen(false);
            setRetomarVoz(Date.now());
            setTimeout(() => chatRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 120);
          }}
        />
      )}

      {showConvert && (
        <ConvertCurrencyModal
          balanceCop={saldos?.cop || 0}
          balanceUsdc={saldos?.usd || 0}
          initialDirection={typeof showConvert === 'object' ? showConvert.direccion : undefined}
          initialAmount={typeof showConvert === 'object' ? showConvert.monto : undefined}
          onClose={() => setShowConvert(false)}
          onSuccess={(nb) => {
            setSaldos({ cop: nb.balance_cop, usd: nb.balance_usdc });
            setShowConvert(false);
          }}
        />
      )}
    </div>
  );
}
